import type { LocalizeFloorPlanLayout } from "./types";

// German users see the detected German names and summaries; a missing one, or any other language, keeps the English.
export const localizeFloorPlanLayout: LocalizeFloorPlanLayout = ({
  layout,
  language,
}) => {
  if (!language.startsWith("de")) return layout;
  return {
    ...layout,
    zones: layout.zones.map((zone) => ({
      ...zone,
      name: zone.nameDe || zone.name,
      summary: zone.summaryDe || zone.summary,
    })),
    rooms: layout.rooms.map((room) =>
      room.nameDe ? { ...room, name: room.nameDe } : room,
    ),
  };
};
